import { createReducer, on } from '@ngrx/store';
import * as BetaFeaturesActions from './beta-features.actions';

export const betaFeaturesFeatureKey = 'betaFeatures';

export interface BetaFeaturesState {
  enabled: boolean;
}

export const initialState: BetaFeaturesState = {
  enabled: false
};

export const reducer = createReducer(
  initialState,
  on(BetaFeaturesActions.enableBetaFeatures, (state) => ({
    ...state,
    enabled: true
  })),
  on(BetaFeaturesActions.disableBetaFeatures, (state) => ({
    ...state,
    enabled: false
  })),
  on(BetaFeaturesActions.setBetaFeatures, (state, { enabled }) => ({
    ...state,
    enabled
  }))
);
